import { v as e, p as t, g as r } from "./_chunks-es/_commonjsHelpers.js";
const o = ["request", "response", "progress", "error", "abort"],
  n = ["processOptions", "validateOptions", "interceptRequest", "finalizeOptions", "onRequest", "onResponse", "onError", "onReturn", "onHeaders"];
function s(r, a) {
  const i = [],
    u = n.reduce((e, t) => (e[t] = e[t] || [], e), {
      processOptions: [t],
      validateOptions: [e]
    });
  function l(e) {
    const t = o.reduce((e, t) => (e[t] = function () {
        const e = /* @__PURE__ */Object.create(null);
        let t = 0;
        return {
          publish: function (t) {
            for (const r in e) e[r](t);
          },
          subscribe: function (r) {
            const o = t++;
            return e[o] = r, function () {
              delete e[o];
            };
          }
        };
      }(), e), {}),
      r = (e => function (t, r, ...o) {
        const n = "onError" === t;
        let s = r;
        for (let r = 0; r < e[t].length && (s = (0, e[t][r])(s, ...o), !n || s); r++);
        return s;
      })(u),
      n = r("processOptions", e);
    r("validateOptions", n);
    const s = {
      options: n,
      channels: t,
      applyMiddleware: r
    };
    let i;
    const l = t.request.subscribe(e => {
      i = a(e, (o, n) => ((e, o, n) => {
        let s = e,
          a = o;
        if (!s) try {
          a = r("onResponse", o, n);
        } catch (e) {
          a = null, s = e;
        }
        s = s && r("onError", s, n), s ? t.error.publish(s) : a && t.response.publish(a);
      })(o, n, e));
    });
    t.abort.subscribe(() => {
      l(), i && i.abort();
    });
    const c = r("onReturn", t, s);
    return c === t && t.request.publish(s), c;
  }
  return l.use = function (e) {
    if (!e) throw new Error("Tried to add middleware that resolved to falsey value");
    if ("function" == typeof e) throw new Error("Tried to add middleware that was a function. It probably expects you to pass options to it.");
    if (e.onReturn && u.onReturn.length > 0) throw new Error("Tried to add new middleware with `onReturn` handler, but another handler has already been registered for this event");
    return n.forEach(t => {
      e[t] && u[t].push(e[t]);
    }), i.push(e), l;
  }, l.clone = () => s(i, a), r.forEach(l.use), l;
}
var a,
  i,
  u = /* @__PURE__ */r(function () {
    if (i) return a;
    i = 1;
    var e = function (e) {
      return e.replace(/^\s+|\s+$/g, "");
    };
    return a = function (t) {
      if (!t) return {};
      for (var r = {}, o = e(t).split("\n"), n = 0; n < o.length; n++) {
        var s = o[n],
          a = s.indexOf(":"),
          i = e(s.slice(0, a)).toLowerCase(),
          u = e(s.slice(a + 1));
        typeof r[i] > "u" ? r[i] = u : (l = r[i], "[object Array]" === Object.prototype.toString.call(l) ? r[i].push(u) : r[i] = [r[i], u]);
      }
      var l;
      return r;
    };
  }());
class l {
  onabort;
  onerror;
  onreadystatechange;
  ontimeout;
  readyState = 0;
  response;
  responseText = "";
  responseType = "";
  status;
  statusText;
  withCredentials;
  #e;
  #t;
  #r;
  #o = {};
  #n;
  #s = {};
  #a;
  open(e, t, r) {
    this.#e = e, this.#t = t, this.#r = "", this.readyState = 1, this.onreadystatechange?.(), this.#n = void 0;
  }
  abort() {
    this.#n && this.#n.abort();
  }
  getAllResponseHeaders() {
    return this.#r;
  }
  setRequestHeader(e, t) {
    this.#o[e] = t;
  }
  setInit(e, t = !0) {
    this.#s = e, this.#a = t;
  }
  send(e) {
    const t = "arraybuffer" !== this.responseType,
      r = {
        ...this.#s,
        method: this.#e,
        headers: this.#o,
        body: e
      };
    "function" == typeof AbortController && this.#a && (this.#n = new AbortController(), typeof EventTarget < "u" && this.#n.signal instanceof EventTarget && (r.signal = this.#n.signal)), typeof document < "u" && (r.credentials = this.withCredentials ? "include" : "omit"), fetch(this.#t, r).then(e => (e.headers.forEach((e, t) => {
      this.#r += `${t}: ${e}\r\n`;
    }), this.status = e.status, this.statusText = e.statusText, this.readyState = 3, this.onreadystatechange?.(), t ? e.text() : e.arrayBuffer())).then(e => {
      "string" == typeof e ? this.responseText = e : this.response = e, this.readyState = 4, this.onreadystatechange?.();
    }).catch(e => {
      "AbortError" !== e.name ? this.onerror?.(e) : this.onabort?.();
    });
  }
}
const c = "function" == typeof XMLHttpRequest ? "xhr" : "fetch",
  h = "xhr" === c ? XMLHttpRequest : l,
  d = (e, t) => {
    const r = e.options,
      o = e.applyMiddleware("finalizeOptions", r),
      n = {},
      s = e.applyMiddleware("interceptRequest", void 0, {
        adapter: c,
        context: e
      });
    if (s) {
      const e = setTimeout(t, 0, null, s);
      return {
        abort: () => clearTimeout(e)
      };
    }
    let a = new h();
    a instanceof l && "object" == typeof o.fetch && a.setInit(o.fetch, o.useAbortSignal ?? !0);
    const i = o.headers,
      d = o.timeout;
    let p = !1,
      f = !1,
      b = !1;
    if (a.onerror = e => {
      m(a instanceof l ? e instanceof Error ? e : new Error(`Request error while attempting to reach is ${o.url}`, {
        cause: e
      }) : new Error(`Request error while attempting to reach is ${o.url}${e.lengthComputable ? `(${e.loaded} of ${e.total} bytes transferred)` : ""}`));
    }, a.ontimeout = e => {
      m(new Error(`Request timeout while attempting to reach ${o.url}${e.lengthComputable ? `(${e.loaded} of ${e.total} bytes transferred)` : ""}`));
    }, a.onabort = () => {
      w(!0), p = !0;
    }, a.onreadystatechange = function () {
      d && (w(), n.socket = setTimeout(() => y("ESOCKETTIMEDOUT"), d.socket)), !p && a && 4 === a.readyState && 0 !== a.status && function () {
        if (!(p || f || b)) {
          if (0 === a.status) return void m(new Error("Unknown XHR error"));
          w(), f = !0, t(null, {
            body: a.response || ("" === a.responseType || "text" === a.responseType ? a.responseText : ""),
            url: o.url,
            method: o.method,
            headers: u(a.getAllResponseHeaders()),
            statusCode: a.status,
            statusMessage: a.statusText
          });
        }
      }();
    }, a.open(o.method, o.url, !0), a.withCredentials = !!o.withCredentials, i && a.setRequestHeader) for (const e in i) i.hasOwnProperty(e) && a.setRequestHeader(e, i[e]);
    return o.rawBody && (a.responseType = "arraybuffer"), e.applyMiddleware("onRequest", {
      options: o,
      adapter: c,
      request: a,
      context: e
    }), a.send(o.body || null), d && (n.connect = setTimeout(() => y("ETIMEDOUT"), d.connect)), {
      abort: function () {
        p = !0, a && a.abort();
      }
    };
    function y(t) {
      b = !0, a.abort();
      const r = new Error("ESOCKETTIMEDOUT" === t ? `Socket timed out on request to ${o.url}` : `Connection timed out on request to ${o.url}`);
      r.code = t, e.channels.error.publish(r);
    }
    function w(e) {
      (e || p || a && a.readyState >= 2 && n.connect) && clearTimeout(n.connect), n.socket && clearTimeout(n.socket);
    }
    function m(e) {
      if (f) return;
      w(!0), f = !0, a = null;
      const r = e || new Error(`Network error while attempting to reach ${o.url}`);
      r.isNetworkError = !0, r.request = o, t(r);
    }
  },
  p = (e = [], t = d) => s(e, t),
  f = "browser";
export { c as adapter, f as environment, p as getIt };